import _ from 'lodash'


import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import { showErrorAlert } from '@/shared/lib/errors'
import { api } from '@/shared/lib/api'

export type FinishResourceProps = {
  type: string
  id: string | number
  action: string
  meta?: Record<string, unknown>
}

export const useFinishResource = () => {
  const { digitalProductId } = useDigitalProductContext()
  const { refetchProgress } = useUserProgress()

  const finishResource = async ({
    type,
    id,
    action,
    meta = {}
  }: FinishResourceProps): Promise<boolean> => {
    if (!type || !id || (!action && !meta && _.isEmpty(meta))) {
      throw new Error('Missing required parameters on handleFinishResource')
    }

    try {
      await api.post(
        `/user/digital_products/${digitalProductId}/progress/finish_resource`,
        {
          record: {
            resource_type: type,
            resource_id: id,
            meta: {
              [action]: true,
              ...meta
            }
          }
        }
      )
      await refetchProgress()
      return true
    } catch (error) {
      showErrorAlert(error)
      return false
    }
  }

  return { finishResource }
}
